import { TileModel } from 'theSource/features/Home/types';
import { Tile } from './components';
import { TileSetWrapperStyled } from './TileSetStyled';

export interface TileSetProps {
  tiles: TileModel[];
}

export const TileSet = ({ tiles }: TileSetProps) => {
  return (
    <TileSetWrapperStyled data-testid="tile-set">
      {tiles.map((tile) => (
        <Tile key={tile.label} {...tile} />
      ))}
    </TileSetWrapperStyled>
  );
};
